export default {
  tos: `
  Al hacer click en registrarse aceptas la
  <a href="/privacy-policy" target="_blank">Política de privacidad</a>
  y los <a href="/terms-of-service" target="_blank">Términos y condiciones</a>
  `
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/tos/es.js